import React from 'react';

import { DropdownItem, DropdownMenu, UncontrolledButtonDropdown } from 'reactstrap';
import PropTypes from 'prop-types';
import { UpwardActions } from '../index';

const BulkActionSelect = ({
   isDisabled,
   dropDownItemList = [],
}) => {
   return (
      <UncontrolledButtonDropdown>
         <UpwardActions disabled={ isDisabled }>Select Bulk Action</UpwardActions>
         <DropdownMenu>
            {
               dropDownItemList.map(({
                  label,
                  dropDownItemProps = {},
               }, idx) => (
                  <DropdownItem { ...dropDownItemProps } key={`${ label }-${ idx }`}>
                     { label }
                  </DropdownItem>
               ))
            }
         </DropdownMenu>
      </UncontrolledButtonDropdown>
   );
};

BulkActionSelect.propTypes = {
   isDisabled: PropTypes.bool,
   dropDownItemList: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      dropDownItemProps: PropTypes.object,
   })).isRequired,
};

BulkActionSelect.defaultProps = {
   isDisabled: false,
};

export default BulkActionSelect;
